module.exports = __webpack_public_path__ + "bfdea755e7aacefe070d159fd669b554.gif";